module.exports = __webpack_public_path__ + "media/images/helpbox_middle-31e96a8f756c832e7856638415695d4b.png";